<template>
  <v-layout column>
    <v-flex>
      <sub-header :subHeaderConfig="subHeaderConfig" />
    </v-flex>
    <v-flex>
      <v-container fluid class="main-content-ctr">
        <v-layout align-start justify-start row>
          <v-flex lg3 shrink class="aside-stepper">
            <stepper-comp :stepperConfig="stepperConfig" />
          </v-flex>
          <v-flex lg8>
            <config-form />
          </v-flex>
          <v-flex lg1>
            <v-spacer></v-spacer>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import SubHeader from '../../components/subheader.vue'
import Stepper from '../../components/stepper.vue'
import ConfigForm from './subbrandConfigForm.vue'

export default {
  components: {
    'sub-header': SubHeader,
    'stepper-comp': Stepper,
    'config-form': ConfigForm
  },
  props: {},
  data() {
    return {}
  },
  created() {
    this.$store.state.appStore.editFlow = false
    this.$store.state.appStore.selectedSubbrandInfo = {}
    this.$store.state.createSubbrandStore.currentStep = 0
    this.$store.state.createSubbrandStore.createTemplateData = JSON.parse(
      JSON.stringify(
        this.$store.state.createSubbrandStore.orgCreateTemplateData
      )
    )
  },
  computed: {
    subHeaderConfig() {
      let config = {
        headerText: this.$lang.messages.create_sub_brand,
        backLink: {
          text: this.$route.params.backText,
          link: this.$route.params.backLink
        }
      }
      return config
    },
    stepperConfig() {
      let config = {
        editFlow: false
      }
      return config
    }
  }
}
</script>

<style>
  .aside-stepper {
    flex-basis: auto !important;
  }
</style>
